import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Faqs/Content';

class Faqs extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Faqs</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'Faqs'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Faqs;